import { InjectionToken } from '@angular/core';
import { BcMessagesManager } from '../widgets';

export const MITEK_MESSAGES_MANAGER = new InjectionToken<BcMessagesManager>('mitek messages',
  { providedIn: 'root', factory: () => new BcMessagesManager() });
